const forms = {
    customerFormData: "customerFormData",
    priceAdjustmentFormData: "priceAdjustment",
    percentualPriceAdjustmentFormData: "percentualPriceAdjustment",
    customerConnectionsFormData: "customerConnections",
    compensationFormData: "compensation",
    compensationTicketFormData: "compensationTicket",
    cancelVossSubscription: "cancelVossSubscription",
    terminateProductGroup: "terminateProductGroup",
    createCustomerDiscountAgreement: "createCustomerDiscountAgreement",
    vonNewEmployeeForm: "vonNewEmployeeForm",
    terminateLicense: "terminateLicense",
    modifySubscription: "modifySubscription",
    changeSubscriptionEmail: "changeSubscriptionEmail",
    releaseNewsForm: "releaseNewsForm"
}

export default forms;